import { createContext } from 'react';
const SidebarContext = createContext({ isOpen: false, setIsOpen: () => {} });
export default SidebarContext;